import { render, staticRenderFns } from "./EquipmentExtras.vue?vue&type=template&id=88d72c6c"
import script from "./EquipmentExtras.vue?vue&type=script&lang=js"
export * from "./EquipmentExtras.vue?vue&type=script&lang=js"
import style0 from "./EquipmentExtras.vue?vue&type=style&index=0&id=88d72c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports